<template>
  <div class="customer-info">
    <div class="app-panel blank-h blank-v">
      <div class="app-control">
        <el-image :src="datas.face_data.attachment_data.attachment_access_url"></el-image>
        <div class="info">
          <p class="text">{{datas.project_customer_open_id}}</p>
          <el-tag size="small" v-if="datas.attr_data.project_customer_attr_gender === 1">男</el-tag>
          <el-tag size="small" type="danger" v-else>女</el-tag>
          <el-tag type="warning" size="small">{{datas.attr_data.project_customer_attr_age}}岁</el-tag>
        </div>
      </div>
    </div>
    <div class="app-panel blank-h blank-v">
      <div class="app-control">
        <p class="title">到访轨迹</p>
      </div>
      <el-table :data="logDatas" v-loading="loading">
        <el-table-column label="到访项目" prop="project_data.project_attr_name"></el-table-column>
        <el-table-column label="首次到访时间" prop="first_recognition_at"></el-table-column>
        <el-table-column label="末次到访时间" prop="last_recognition_at"></el-table-column>
        <el-table-column label="到访次数" prop="day_count"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="scan(row.project_id)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer :title="dialog.title" :visible.sync="dialog.show" center append-to-body>
      <el-timeline>
        <el-timeline-item hide-timestamp v-for="(value, index) in logInfo" :key="index">
          <div class="app-control">
            <span>{{value.recognition_day}}</span><span>抓拍次数：{{value.day_count}}次</span>
            <div class="right-region">
              <div class="btn" @click="showLogInfoList(value)">
                <i class="el-icon-loading" v-if="value.loading"></i>
                <template v-else>
                  <i class="el-icon-bottom" v-if="value.open"></i>
                  <i class="el-icon-right" v-else></i>
                </template>
              </div>
            </div>
          </div>
          <div class="items" v-if="value.list.length">
            <div class="app-control" v-for="(m, n) in value.list" :key="n">
              <span>{{m.project_customer_recognition_log_recognition_at.split(' ')[1]}}</span>
              <el-image :src="m.provide_attachment_data.attachment_access_url" :preview-src-list="[m.provide_attachment_data.attachment_access_url]"></el-image>
              <span>{{m.project_customer_recognition_log_location_name}}</span>
              <div class="right-region">
                <el-button type="text" @click="scanLargeImage(m.provide_large_attachment_data.attachment_access_url)">查看大图</el-button>
              </div>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
      <el-image-viewer :urlList="largeImage.value" :onClose="closeLargeImage" v-if="largeImage.show"></el-image-viewer>
    </el-drawer>
  </div>
</template>

<script>
  import CustomerService from '@/io/customer.js';
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer.vue';

  export default {
    name: 'CustomerInfo',
    props: {
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        largeImage: {
          show: false,
          value: []
        },
        dialog: {
          title: '到访轨迹详情',
          show: false
        },
        datas: {
          face_data: {
            attachment_data: {}
          },
          attr_data: {}
        },
        loading: false,
        projectId: '',
        logDatas: [],
        logInfo: []
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initDatas();
            this.initLogDatas();
          }
        },
        immediate: true
      }
    },
    components: {
      ElImageViewer,
    },
    methods: {
      scanLargeImage(src) {
        this.setWaterMark('本图片仅用于视频监控', `${this.$store.state.userInfo.account_attr_data.account_attr_name}`);
        this.largeImage.value = [src];
        this.largeImage.show = true;
      },
      closeLargeImage() {
        this.removeWatermark();
        this.largeImage.value = [];
        this.largeImage.show = false;
      },
      initDatas() {
        CustomerService.info(this.id).then(res => {
          this.datas = res.data;
        }).catch(() => {});
      },
      initLogDatas() {
        this.loading = true;
        CustomerService.logList(this.id).then(res => {
          this.logDatas = res.data;
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      scan(project_id) {
        this.dialog.show = true;
        this.projectId = project_id;
        CustomerService.logInfo(this.id, this.projectId).then(res => {
          this.logInfo = res.data.map(val => {
            val.loading = false;
            val.open = false;
            val.list = [];
            return val;
          });
        }).catch(() => {});
      },
      showLogInfoList(data) {
        if (data.loading) {
          return;
        }
        if (data.open) {
          data.open = false;
          data.list = [];
        } else {
          data.loading = true;
          CustomerService.logInfoList(this.id, this.projectId, data.recognition_day).then(res => {
            data.list = res.data;
            data.open = true;
          }).catch(() => {}).finally(() => {
            data.loading = false;
          });
        }
      }
    },
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .customer-info {
    .app-panel {
      & + .app-panel {
        margin-top: @distance;
      }
      .app-control {
        margin: 0 -10px;
        & > * {
          margin: 0 10px;
        }
        .el-image {
          width: 100px;
          height: 100px;
          border-radius: 50%;
        }
        .info {
          .text {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 10px;
          }
          .el-tag {
            min-width: 45px;
            text-align: center;
          }
        }
        .right-region {
          & > p {
            padding: 20px;
            border-radius: 4px;
            span {
              text-align: center;
              display: block;
              padding: 5px;
              &:nth-of-type(1) {
                font-weight: bold;
                color: @color-primary;
              }
              &:nth-of-type(2) {
                font-weight: bold;
                color: @color-text-3;
              }
            }
          }
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          i {
            margin-right: 5px;
            color: @color-primary;
          }
        }
      }
      .el-table {
        margin-top: @distance;
      }
    }
  }
  /deep/ .el-timeline {
    padding: 25px 20px 0 20px;
    .el-timeline-item {
      .el-timeline-item__wrapper {
        top: -25px;
        .el-timeline-item__content {
          background-color: @color-4;
          padding: 15px 20px;
          border-radius: 6px;
          .app-control {
            .btn {
              width: 30px;
              height: 30px;
              color: @color-primary;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              transition: all @time;
              cursor: pointer;
              &:hover {
                background-color: @color-primary;
                color: @color-white;
              }
            }
          }
          .items {
            border-top: 1px solid @color-border-2;
            margin-top: 15px;
            padding-top: 15px;
            & > .app-control {
              margin: 0 -10px;
              & + .app-control {
                margin-top: 15px;
              }
              & > * {
                margin: 0 10px;
              }
              .el-image {
                width: 50px;
                height: 50px;
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
</style>